module.exports = __webpack_public_path__ + "static/img/pic_titlieyzsd@2x.8b916a4d.png";